import { CommonLanguage } from '../../transport.interface';

export class SaveLanguagesAction {
  static readonly type = '[Languages] Save';

  constructor(public payload: CommonLanguage[]) {
  }
}
